<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button class="filter-item" type="primary" @click="handleCreate">新增</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column label="图片" min-width="110" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.picture" class="user-avatar">
        </template>
      </el-table-column>

      <el-table-column label="链接类型" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.link_type === 0">无</el-tag>
          <el-tag type="primary" v-else-if="scope.row.link_type === 1">商品页面</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="链接" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.link }}
        </template>
      </el-table-column>

      <el-table-column label="权重" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.weight }}
        </template>
      </el-table-column>

      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_on === 1" type="success">正常</el-tag>
          <el-tag v-else-if="scope.row.is_on === 0" type="danger">下架</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="200" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleUpdate(scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[10,20,30,50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
    </div>

    <!-- 详情 -->
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" width="60%" :close-on-click-modal="false">
      <el-form ref="form" :rules="rules" :model="form" label-width="150px">
        <el-form-item label="图片" prop="picture">
          <upload-one v-model="form.picture"></upload-one>
          <div style="font-size:12px;color:red;">*推荐尺寸：750*380</div>
        </el-form-item>

        <el-form-item label="链接类型" prop="link_type">
          <el-select v-model="form.link_type">
            <el-option label="无" :value="0"></el-option>
            <el-option label="商品页面" :value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="链接" prop="link">
          <el-input v-model="form.link"></el-input>
          <div style="line-height:16px;font-size: 12px;color:red;margin-top:10px;">
            <div>*商品页面，此处填写商品ID，只支持积分商城的商品ID</div>
          </div>
        </el-form-item>

        <el-form-item label="权重" prop="weight">
          <el-input-number v-model="form.weight" :min="1" :precision="0" style="width: 100%;max-width: 220px;"></el-input-number>
          <div style="line-height:16px;font-size: 12px;color:red;margin-top:10px;">
            <div>*权重越小，排名越前</div>
          </div>
        </el-form-item>

        <el-form-item label="状态" prop="is_on">
          <el-switch v-model="form.is_on" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 详情 -->
  </div>
</template>

<script>
  import request from "@/utils/request";
  import { mapGetters } from "vuex";

  export default {
    data() {
      return {
        list: null,
        total: null,
        listLoading: true,
        listQuery: {
          page: 1,
          limit: 10,
        },
        dialogFormVisible: false,
        dialogStatus: "",
        textMap: {
          update: "修改",
          create: "新增",
        },
        btnLoading: false,
        form:{
          id: "",
          picture: "",
          link_type: 0,
          link: "",
          weight: 1,
          is_on: 1,
        },
        rules: {
          picture: [{ required: true, message: "图片不能为空", trigger: "change" }],
          link_type: [{ required: true, message: "链接类型不能为空", trigger: "change" }],
          weight: [{ required: true, message: "权重不能为空", trigger: "change" }],
          is_on: [{ required: true, message: "状态不能为空", trigger: "change" }],
        },
      };
    },
    created() {
      this.getList();
    },
    computed: {
      ...mapGetters(["schools","school_id","user"])
    },
    methods: {
      getList() {
        this.listLoading = true;
        request({
          url: "/api/backend/mallBanner/list",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.list = response.data.data;
          this.total = response.data.total;
          this.listLoading = false;
        });
      },
      handleFilter() {
        this.listQuery.page = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.page = val;
        this.getList();
      },
      resetForm() {
        this.form = {
          id: "",
          picture: "",
          link_type: 0,
          link: "",
          weight: 1,
          is_on: 1,
        }
        this.btnLoading = false;
      },
      handleCreate() {
        this.resetForm()
        this.dialogStatus = "create"
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs["form"].clearValidate() //清除校验结果
        })
      },
      handleUpdate(row) {
        this.resetForm()
        this.form = Object.assign({}, row)
        this.dialogStatus = "update"
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs["form"].clearValidate() //清除校验结果
        })
      },
      saveData() {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.btnLoading = true
            request({
              url: "/api/backend/mallBanner/save",
              method: "post",
              data: this.form
            }).then(() => {
              this.btnLoading = false
              this.dialogFormVisible = false
              this.$message({
                type: "success",
                message: "操作成功"
              });
              this.getList();
            }).catch(() => {
              this.btnLoading = false
            })
          }
        })
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .user-avatar {
    width: 120px;
    height: 60px;
    border-radius: 6px;
  }
</style>
